"use client"

import styled from "@emotion/styled"
import { Typography } from "@mui/material"
import { CustomBreadcrumbs } from "ui"
import Container from "ui/Container"
import { BreadCrumbs } from "utils"

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 16px;
  padding-bottom: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 16px;
    padding-top: 48px;
    padding-bottom: 32px;
  }
`

type Props = {
  breadCrumbs: BreadCrumbs
  title?: string
}

export default function PageHeader({ breadCrumbs, title }: Props) {
  return (
    <Container paddingMobile>
      <StyledContainer>
        <CustomBreadcrumbs breadcrumbs={breadCrumbs} noPadding />
        {title && (
          <Typography variant="h2" component="h1">
            {title}
          </Typography>
        )}
      </StyledContainer>
    </Container>
  )
}
